module.exports = "<p>\n  widget-warehouse-damage works!\n</p>\n"